// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1ebd5df5","160":"0d984008","208":"631928ce","293":"85032427","516":"42766a0c","519":"3a69dc1e","840":"532eaa1a","917":"823c1faf","946":"da3d13f7"}[chunkId] + ".chunk.js";
};